import { createStyles } from "../../../styles/theme";

export const CalculatePriceModalStyles = createStyles({
  bottomSection: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
});
